import React, { useContext } from "react";

import "../../../../../assets/css/utility/input-field.css";
import "../../../../../assets/css/utility/map.css";
import "../../../../../assets/css/create-load-post.css";
import OriginDestinationSelectionMap from "./OriginDestinationSelectionMap";
import Origin from "./Origin";
import Destination from "./Destination";
import { ManageLoadPostContext } from "../../";

const AddressInformation = ({ isForUpdate }) => {
  const [loadPostState, loadPostContextDispatch] = useContext(
    ManageLoadPostContext
  );

  const validateStepOne = () => {
    // Clear error messages
    loadPostContextDispatch({ type: "CLEAR_STEP_ONE_ERROR_MESSAGES" });

    const addressInformationRequiredFieldList = [
      "origin_contact_name",
      "origin_contact_phone_number",
      "origin_address",
      "origin_city",
      "origin_state",
      "origin_country",
      "origin_postal_code",
      "origin_latitude",
      "origin_longitude",
      "is_origin_auction",
      "destination_contact_name",
      "destination_contact_phone_number",
      "destination_address",
      "destination_city",
      "destination_state",
      "destination_country",
      "destination_postal_code",
      "destination_latitude",
      "destination_longitude",
      "is_destination_port",
    ];

    // Validate all fields
    let isValid = true;
    addressInformationRequiredFieldList.forEach((field) => {
      if (
        ["", null, undefined].includes(loadPostState?.loadPostInfo[field]) &&
        field !== "is_origin_auction" &&
        field !== "is_destination_port"
      ) {
        isValid = false;

        // Set error messages
        loadPostContextDispatch({
          type: "MANAGE_ERROR_MESSAGES",
          payload: {
            name: field,
            value: ["This field is required"],
          },
        });
      }
    });
    return isValid;
  };

  const handleNextStep = () => {
    // Validate step one
    if (!validateStepOne()) {
      window.scrollTo(0, 0);
      return;
    }

    // Go to next step
    loadPostContextDispatch({ type: "CHANGE_STEP", payload: 2 });
  };

  return (
    <>
      <section id="load-post-origin-destination">
        <div className="container theme-section">
          <div className="row load-post-address">
            <div className="col-md-6 pe-4">
              <h1>Origin</h1>

              <Origin />
            </div>

            <div className="col-md-6 ps-4">
              <h1>Destination</h1>

              <Destination />
            </div>
          </div>
        </div>
      </section>

      <OriginDestinationSelectionMap isForUpdate={isForUpdate} />

      <section id="load-post-btn">
        <div className="container">
          <div className="multiple-btn">
            <button onClick={handleNextStep}> Next</button>
            {/* <button>Save As Draft</button> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(AddressInformation);
